import script from "./modelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./modelDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__